module.exports = __webpack_public_path__ + "static/02-91590ac3df891c78c587a27bbb089446.jpg";